import { DOCUMENT, DestroyRef, Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { manifestZaUrl } from './pwa-rute';

/**
 * Drži `<link rel="manifest">` u `<head>` samo na rutama aplikacije (`pwa-rute.ts`).
 * Na javnim stranicama linka nema, pa Chrome na njima ne nudi instalaciju
 * (ni `beforeinstallprompt` ni stavku „Instaliraj” u izborniku).
 *
 * Chrome prati promjenu linka; WebKit (Safari, iOS) učitava manifest jednom po dokumentu
 * (`DocumentLoader::loadApplicationManifest`), pa za „Dodaj na početni zaslon” vrijedi prvi
 * manifest stranice. Osobni link klijenta otvara se svježim učitavanjem `/k/<token>`, pa je prvi
 * manifest upravo onaj tog tokena.
 */
@Injectable({ providedIn: 'root' })
export class PwaManifestService {
  private readonly router = inject(Router);
  private readonly doc = inject(DOCUMENT);
  private readonly destroyRef = inject(DestroyRef);
  private pokrenut = false;

  pokreni(): void {
    if (this.pokrenut) {
      return;
    }
    this.pokrenut = true;
    const pretplata = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(e => this.primijeni(e.urlAfterRedirects));
    this.destroyRef.onDestroy(() => pretplata.unsubscribe());
  }

  /** Postavi ili ukloni link za URL (javno radi testova). */
  primijeni(url: string): void {
    const href = manifestZaUrl(url);
    const postojeci = Array.from(this.doc.head.querySelectorAll<HTMLLinkElement>('link[rel="manifest"]'));
    if (!href) {
      postojeci.forEach(l => l.remove());
      return;
    }
    const [link, ...visak] = postojeci;
    visak.forEach(l => l.remove());
    if (link) {
      if (link.getAttribute('href') !== href) {
        link.setAttribute('href', href);
      }
      return;
    }
    const novi = this.doc.createElement('link');
    novi.rel = 'manifest';
    novi.href = href;
    this.doc.head.appendChild(novi);
  }
}
